import { render, staticRenderFns } from "./ChannelGrantDlg.vue?vue&type=template&id=485a1e2a"
import script from "./ChannelGrantDlg.vue?vue&type=script&lang=js"
export * from "./ChannelGrantDlg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports